import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { getAgencyLanguages } from './api';

export function useGetAgencyLanguages(options?: UseQueryOptions<{ data: string[] }, Error>) {
  return useQuery<{ data: string[] }>({
    queryKey: ['agency_languages'],
    queryFn: () => getAgencyLanguages(),
    ...options
  });
}
